module.exports = "../../static/img/splash.4f0654a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/splash.jpg
// module id = wY26
// module chunks = 2